import { render, staticRenderFns } from "./AamsLicenseBaseCategory.vue?vue&type=template&id=dfba25d0&scoped=true&"
import script from "./AamsLicenseBaseCategory.vue?vue&type=script&lang=js&"
export * from "./AamsLicenseBaseCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfba25d0",
  null
  
)

export default component.exports